import Base64 from 'crypto-js/enc-base64';
import hmacSHA256 from 'crypto-js/hmac-sha256';

import { setDeviceID } from '../app/apiScreenSlice';
import { store } from '../app/store';
import { isiOSWebkit } from './sdk';
import { SESSION_STORAGE } from './sessionStorageConstants';

export function getDeviceID(): string {
  if (isiOSWebkit()) {
    store.dispatch(
      setDeviceID(sessionStorage.getItem(SESSION_STORAGE.DEVICE_ID))
    );
  }

  const storedDeviceID = store.getState().apiScreenScreenSelector.deviceID;

  if (storedDeviceID !== '') {
    return storedDeviceID;
  }

  // UUID created using current date (for uniqueness) + Math.random() (for more uniqueness)
  const newUUID =
    Date.now().toString(36) + Math.random().toString(36).substring(2);
  store.dispatch(setDeviceID(newUUID));
  return newUUID;
}

/**
 * Asynchronously retrieves a valid API key from the application state.
 * Waits for a maximum of 3 seconds for the API key to become defined.
 * Returns empty if the API key is not defined within this timeframe.
 */
export async function getApiKey() {
  return new Promise<string>((resolve) => {
    const startTime = Date.now();
    const maxWaitTime = 3000; // 3 seconds

    const checkApiKey = () => {
      const apiKey = store.getState().apiScreenScreenSelector.apikey;
      if (apiKey !== undefined && apiKey !== '') {
        resolve(apiKey);
      } else {
        if (Date.now() - startTime >= maxWaitTime) {
          resolve(''); // Return empty if apiKey is still empty after 3 seconds
        } else {
          setTimeout(checkApiKey, 100); // Check again after 100 milliseconds
        }
      }
    };

    checkApiKey();
  });
}

export async function getSignature(url: string, body?: any): Promise<string> {
  const apiKey = await getApiKey();
  const parsedUrl = url.split('?')[0];

  if (apiKey) {
    let hashVal = `${JSON.stringify(body)}:${parsedUrl}`;
    if (!body) hashVal = `:${parsedUrl}`;

    return Base64.stringify(hmacSHA256(hashVal, apiKey));
  }
  return '';
}
